import { MdLocalActivity } from "react-icons/md";
import { statsAdminService } from "services/admin/statsService";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const TourCount = ({ month }) => {
  const q = useDashboardQuery(["tours-count", month], async () => (await statsAdminService.getToursCount({ month })).data);

  return (
    <KpiCard
      icon={MdLocalActivity}
      accent="pink"
      label="Туры"
      hint="Турпакеты за выбранный период"
      to="/admin/tour-packages/list"
      value={formatNumber(q.data)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default TourCount;
